<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <!-- <el-tab-pane label="VAT Relief (Esubmission)" name="esubmission">
        <esubmission ref="esubmission"/>
      </el-tab-pane> -->
      <el-tab-pane label="eBIRForms" name="eBIRForms">
        {{msg}}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Esubmission from '@/components/taxation/salesTaxPortal/salesTaxFiling/Esubmission.vue'

  export default {
    name: 'salesTaxFiling',
    components: {
      Esubmission,
    },
    data() {
      return {
        activeTab: 'eBIRForms',
        msg: 'Sorry, this feature now under development will be ready later.',
      }
    },
    methods: {
      loadFirstTab() {
        this.activeTab = 'eBIRForms'
        // this.$refs['eBIRForms'].loadList()
      },
      handleClick(tab, event) {
        if (tab.name === 'esubmission'){
          this.$refs['esubmission'].loadList()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>